document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('[data-recently-viewed-tab]');

  containers.forEach(container => {
    const key = 'theme:recently-viewed-products';
    const sectionHandle = 'recently-viewed-tab';

    const ids = JSON.parse(localStorage.getItem(key) || '[]');
    if (!ids.length) {
      return;
    }

    const query = ids.map(id => `id:${id}`).join(' OR ');
    const url = `/search?type=product&q=${encodeURIComponent(query)}&section_id=${sectionHandle}`;

    fetch(url)
      .then(res => res.text())
      .then(html => {
        container.innerHTML = html;
      })
      .catch(err => {
        console.error('[RecentlyViewed] Error fetching products:', err);
      });
  });
});
